import React from 'react';
import { useTranslation } from 'react-i18next';

import configService from '../../services/config.service';
export const CloseEye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  );
};

export const OpenEye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const RightSign = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 mr-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
      />
    </svg>
  );
};

export const ClockRunningIcon = (_bold = false) => {
  return (
    <>
      {_bold ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6 mr-2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6 mr-2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      )}
    </>
  );
};

export const CrossSignIcon = (_bold = false) => {
  return (
    <>
      {_bold ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6 mr-2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      )}
    </>
  );
};
export const UploadIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5508 9.10937C15.5508 9.0625 15.5586 9.01563 15.5586 8.96875C15.5586 6.42969 13.5352 4.375 11.0391 4.375C9.23828 4.375 7.69141 5.44531 6.96484 6.99219C6.64844 6.83203 6.29297 6.73828 5.91797 6.73828C4.76562 6.73828 3.80469 7.59375 3.62109 8.71094C2.23828 9.1875 1.25 10.5117 1.25 12.0703C1.25 14.0313 2.81641 15.625 4.74609 15.625H8.75V12.5H6.86719L10 9.23047L13.1328 12.4961H11.25V15.6211H15.5586C17.3242 15.6211 18.75 14.1563 18.75 12.3633C18.75 10.5703 17.3164 9.11328 15.5508 9.10937Z"
        fill="white"
      />
    </svg>
  );
};

export const GreaterThanSignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 4.5l7.5 7.5-7.5 7.5"
      />
    </svg>
  );
};

export const LessThanSignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 19.5L8.25 12l7.5-7.5"
      />
    </svg>
  );
};

export const PlanRightSignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 12.75 6 6 9-13.5"
      />
    </svg>
  );
};

export const PlusSignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 mr-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 ml-3"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
      />
    </svg>
  );
};

export const TitlesViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4 ml-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
      />
    </svg>
  );
};

export const ListViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4 ml-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
      />
    </svg>
  );
};

export const BrownClockRunningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#625102"
      className="w-8 h-8 animate-spin mr-3 "
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

export const BrownCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#a08b5f"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

export const LeftArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4 mr-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
      />
    </svg>
  );
};

export const OpenNewTabIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 ml-1"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      />
    </svg>
  );
};

export const CircleRunningIcon = () => {
  return (
    <svg
      className="animate-spin h-5 w-5 text-black mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export const CopySignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6     "
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
      />
    </svg>
  );
};

export const ThreeDotsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
      />
    </svg>
  );
};

export const DashboardSvgIcon = () => {
  return (
    <img
      src="/img/menu-icons/dashboard.svg"
      alt="Dashboard"
      className="dark:brightness-0 dark:invert group-hover:dark:invert-0 group-hover:dark:brightness-150 md:mx-auto md:mb-2 md:w-9 w-7 md:mr-auto mr-3"
    />
  );
};

export const AssetsSvgIcon = () => {
  return (
    <img
      src="/img/menu-icons/projects.svg"
      alt="Assets"
      className="dark:brightness-0 dark:invert group-hover:dark:invert-0 group-hover:dark:brightness-150 md:mx-auto md:mb-2 md:w-9 w-7 md:mr-atuo mr-3"
    />
  );
};

export const OwnedAssetsSvgIcon = () => {
  return (
    <img
      src="/img/menu-icons/own-assets.svg"
      alt="Owned Assets"
      className="dark:brightness-0 dark:invert group-hover:dark:invert-0 group-hover:dark:brightness-150 md:mx-auto md:mb-2 md:w-9 w-7 md:mr-atuo mr-3"
    />
  );
};

export const ProjectsSvgIcon = () => {
  return (
    <img
      src="/img/menu-icons/transactions.svg"
      alt="Projects"
      className="dark:brightness-0 dark:invert group-hover:dark:invert-0 group-hover:dark:brightness-150 md:mx-auto md:mb-2 md:w-9 w-7 md:mr-atuo mr-3"
    />
  );
};

export const SoldOutListingSvgIcon = () => {
  return (
    <img
      src="/img/sold-out-listing.svg"
      className="absolute top-0 right-0"
      alt=""
    />
  );
};

export const SoldOutListingDutchSvgIcon = () => {
  return (
    <img
      src="/img/sold-out-listing-d.svg"
      className="absolute top-0 right-0"
      alt=""
    />
  );
};

export const IconLocationSvgIcon = () => {
  return <img src="/img/iconlocation.svg" alt="project" className="w-full" />;
};

export const AssetbloxLogoSvgIcon = () => {
  return (
    <img
      src="/img/platform-logo-dark.png"
      alt="Dashboard"
      className="md:mx-auto mb-2 w-32"
    />
  );
};

export const AssetbloxLogoDarkSvgIcon = () => {
  return (
    <img
      src="/img/platform-logo-dark.png"
      alt="logo"
      className="mx-auto w-32 dark:brightness-0 dark:invert"
    />
  );
};

export const AssetbloxLogoDark2SvgIcon = () => {
  return (
    <img
      alt=""
      src="/img/platform-logo-dark.png"
      className="mx-auto w-32 darkModeLogo"
    />
  );
};

export const AssetbloxLogoWhiteSvgIcon = () => {
  return (
    <img
      src="/img/platform-logo-white.png"
      className="md:block hidden max-w-[130px]"
      alt={configService.appName() + ' Logo'}
    />
  );
};

export const CloseButtonSvgIcon = () => {
  return <img src="/img/closebutton.svg" className="inline-block w-8" alt="" />;
};

export const DownloadSvgIcon = () => {
  return <img src="/img/downloadicon.svg" className="" alt="" />;
};

export const LinkDirectionSvgIcon = () => {
  return <img src="/img/linkdirection-icon.svg" className="mr-2" alt="" />;
};

export const GoogleSvgIcon = () => {
  return <img alt="" src="/img/googleicon.svg" className="mr-2" />;
};

export const LinkedinSvgIcon = () => {
  return <img alt="" src="/img/linkedinicon.svg" className="mr-2" />;
};

export const PageNotFoundSvgIcon = () => {
  return <img src="/img/404.svg" className="mx-auto mb-3" alt="404" />;
};

export const EnergyBarTopSvgIcon = () => {
  return <img className="z-[4]" src="/img/energy-bars/new-top.svg" alt="" />;
};

export const EcoTopSvgIcon = () => (
  <img className="z-[4]" src="/img/energy-bars/eco-top.svg" alt="Eco Top" />
);

export const ElectricTopSvgIcon = () => (
  <img
    className="z-[4]"
    src="/img/energy-bars/electric-top.svg"
    alt="Electric Top"
  />
);

export const GeothermalTopSvgIcon = () => (
  <img
    className="z-[4]"
    src="/img/energy-bars/geo-top.svg"
    alt="Geothermal Top"
  />
);

export const SolarTopSvgIcon = () => (
  <img className="z-[4]" src="/img/energy-bars/solar-top.svg" alt="Solar Top" />
);

export const WindTopSvgIcon = () => (
  <img className="z-[4]" src="/img/energy-bars/wind-top.svg" alt="Wind Top" />
);

export const EcoDownSvgIcon = () => (
  <img className="z-[2]" src="/img/energy-bars/eco-down.svg" alt="Eco Down" />
);

export const ElectricDownSvgIcon = () => (
  <img
    className="z-[2]"
    src="/img/energy-bars/electric-down.svg"
    alt="Electric Down"
  />
);

export const SolarDownSvgIcon = () => (
  <img
    className="z-[2]"
    src="/img/energy-bars/solar-down.svg"
    alt="Electric Down"
  />
);

export const GeothermalDownSvgIcon = () => (
  <img
    className="z-[2]"
    src="/img/energy-bars/geo-down.svg"
    alt="Geothermal Down"
  />
);

export const WindDownSvgIcon = () => (
  <img className="z-[2]" src="/img/energy-bars/wind-down.svg" alt="Wind Down" />
);

export const SoldOutSvgIcon = () => {
  return (
    <img alt="" src="/img/sold-out.svg" className="absolute top-0 left-0" />
  );
};

export const RepaidListingSvgIcon = ({ language }) => {
  const lang =
    language === 'en' ? '/img/repaid-img.svg' : '/img/repaid-dutch.svg';
  return <img src={lang} className="absolute top-0 right-0" alt="repaid-img" />;
};

export const SoldOutDutchSvgIcon = () => {
  return (
    <img alt="" src="/img/sold-out-d.svg" className="absolute top-0 left-0" />
  );
};

export const QuestIsinSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="ISIN-tooltip"
      data-tooltip-content={t('ISIN-tooltip')}
    />
  );
};

export const QuestNominalSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="nominal-value-tooltip"
      data-tooltip-content={t('nominal-value-tooltip')}
    />
  );
};

export const QuestPriceSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="price-tooltip"
      data-tooltip-content={t('price-tooltip')}
    />
  );
};

export const QuestAnnualInterestSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="annual-interest-tooltip"
      data-tooltip-content={t('annual-interest-tooltip')}
    />
  );
};

export const QuestAnnualYieldSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="annual-yield-tooltip"
      data-tooltip-content={t('annual-yield-tooltip')}
    />
  );
};

export const QuestRepaymentSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="repayment-type-tooltip"
      data-tooltip-content={t('repayment-type-tooltip')}
    />
  );
};

export const QuestInriscSvgIcon = () => {
  const { t } = useTranslation('projectDetails');
  return (
    <img
      src="/img/quest-icon.svg"
      className="ml-2"
      alt="quest-icon"
      data-tooltip-id="inrisc-score-tooltip"
      data-tooltip-content={t('inRisc_score_tooltip')}
    />
  );
};

export const SendSvgIcon = () => {
  return <img src="/img/send-icon.svg" className="mr-2" alt="icon" />;
};
